import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'

// 디자인 정본: englishflat-design /projects/graphics/mathflat-landing-banner → -mathflat-landing/EntryModals.tsx
// 얼리버드 신청 모달과 같은 상자(494 · 여백 24 · radius 4 · 버튼 120×40)를 쓴다.
const MODAL_W = 494
const COPY_W = MODAL_W - 48
// 여백 24 + [심볼 36 + 10 + 제목 24 + 10 + 본문 42] + 사이 24 + 버튼 40 + 24.
const BOX_H = 234
const MARK_BOX = 36

const shell = css`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${MODAL_W}px;
  padding: 24px;
  background: var(--White);
  border-radius: var(--Radius-100);
`

const buttonBase = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 40px;
  padding: 0 12px;
  box-sizing: border-box;
  border: 0;
  border-radius: var(--Radius-100);
  background: var(--Colors-Gray-200);
  font-family: inherit;
  ${typo.body02};
  font-weight: 400;
  color: var(--Colors-Gray-800);
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
`

const S = {
  modal: css`
    ${shell};
    height: ${BOX_H}px;
  `,
  // 다른 모달과 달리 높이를 박지 않는다 — 절차 줄 수와 문구 길이가 브랜드마다 달라
  // 상수로 두면 문구를 고칠 때마다 높이를 같이 계산해야 하고, 빠뜨리면 버튼이 상자 밖으로 밀린다.
  // 여백 24 와 버튼 자리는 shell 이 잡으므로 모양은 유지된다.
  adminModal: css`
    ${shell};
  `,
  // 심볼 자리는 36 칸으로 두고 그 안에 24 를 앉힌다 — 아이콘을 쓰는 모달과 첫 줄 높이를 맞춘다.
  mark: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${MARK_BOX}px;
    height: ${MARK_BOX}px;

    img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  `,
  // 스쿨플랫은 깃발 하나를 과목 색 배경에 올린다 — 드롭다운 심볼과 같은 방식.
  // 모서리는 드롭다운 심볼과 같은 Radius-200 을 쓴다. 칸이 30 에서 36 으로 커진 만큼
  // 깃발도 20 에서 24 로 올려 비율(2/3)을 맞춘다.
  markTinted: css`
    border-radius: var(--Radius-200);
    overflow: hidden;
  `,
  title: css`
    margin: 10px 0 0;
    ${typo.heading05};
    font-weight: 700;
    color: var(--Colors-Gray-900);
    text-align: center;
  `,
  body: css`
    margin: 10px 0 0;
    width: ${COPY_W}px;
    ${typo.body02};
    color: var(--Colors-Gray-900);
    text-align: center;

    b {
      font-weight: 700;
      color: var(--Colors-Violet-400);
    }
  `,
  // 제목이 없는 모달은 본문이 첫 줄이라 한 단계 굵게 세우고 위 여백을 걷는다.
  leadBody: css`
    margin-top: 0;
    ${typo.body01};
    font-weight: 500;
  `,
  // 절차는 본문이 아니라 "이렇게 하면 풀린다"는 안내라 색으로 한 단계 죽인다.
  // 줄마다 가운데 정렬이라 길이가 다른 두 줄의 왼쪽이 어긋나는 것은 의도된 모양이다.
  steps: css`
    margin: 10px 0 0;
    padding: 0;
    max-width: ${COPY_W}px;
    list-style: none;
    ${typo.body02};
    color: var(--Colors-Gray-700);
    text-align: center;

    li {
      display: flex;
      justify-content: center;
      gap: 4px;
    }
  `,
  // 가운데 정렬이라 번호를 고정폭 칸에 넣지 않는다 — 넣으면 짧은 번호 쪽에 빈 칸이 생겨
  // 줄의 중심이 글자 중심과 어긋난다.
  stepNo: css`
    flex: none;
  `,
  buttons: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 24px;
  `,
  button: buttonBase,
  ctaButton: css`
    ${buttonBase};
    background: var(--Colors-Sky-400);
    font-weight: 700;
    color: var(--White);
  `,
}

export default S
